/**
 * Validações puras do cadastro de cliente no balcão (`containers/CustomerCreate`).
 *
 * Espelham o que o backend exige em `POST /customers`
 * (`customers-validator.ts:createCustomerModelChain`):
 *   - celular: 10 a 11 dígitos, obrigatório
 *   - confirmPassword: `Joi.ref('password')`, ou seja, se vier tem que bater
 *
 * Ficam aqui, e não no componente, porque é a única parte testável da tela —
 * o resto depende de `useDataProvider`.
 */

const MIN_CELLPHONE_DIGITS = 10;
const MAX_CELLPHONE_DIGITS = 11;

/**
 * O valor chega só com dígitos: o `parse` do `CellphoneInput` tira a máscara
 * antes de gravar no estado do formulário.
 */
export const validateCellphone = value => {
    if (!value) { return 'Campo obrigatório'; }
    return value.length < MIN_CELLPHONE_DIGITS || value.length > MAX_CELLPHONE_DIGITS
        ? 'Celular inválido'
        : undefined;
};

/**
 * Validação de formulário (cross-field). Só reclama quando os dois campos estão
 * preenchidos — o "obrigatório" de cada um é responsabilidade do `required()`
 * do próprio input, e duplicar aqui faria a tela mostrar dois erros no mesmo campo.
 */
export const validateForm = (values = {}) => {
    const errors = {};
    if (values.password && values.confirmPassword && values.password !== values.confirmPassword) {
        errors.confirmPassword = 'As senhas não conferem';
    }
    return errors;
};
